export default __webpack_public_path__ + "c3011c5de1114a8702b9a539768ce159.png";